import { Stack } from '@mui/material';
import { FormTextField } from 'src/components/Forms/FormTextField/form-text-field';
import {
  BLOCK_SHORT_TEXTAREA_PROPS,
  BLOCK_TEXT_FIELD_PROPS,
} from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/field-props';
import { MediaFields } from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/media-fields';
import { blockFieldName } from 'src/pages/Settings/memberships/components/landing-page-tab/types';

interface HeroBlockFieldsProps {
  index: number;
  readOnly: boolean;
}

export const HeroBlockFields = ({ index, readOnly }: HeroBlockFieldsProps) => (
  <Stack gap={2.5}>
    <FormTextField
      type="textfield"
      name={blockFieldName(index, 'heroHeadline')}
      label="Headline"
      required="Headline is required"
      disabled={readOnly}
      textFieldProps={BLOCK_TEXT_FIELD_PROPS}
      description="Wrap words in *asterisks* to accent them."
    />

    <FormTextField
      type="textfield"
      name={blockFieldName(index, 'heroSubtext')}
      label="Subtext"
      disabled={readOnly}
      textFieldProps={BLOCK_SHORT_TEXTAREA_PROPS}
    />

    <MediaFields index={index} prefix="hero" readOnly={readOnly} />
  </Stack>
);
